/**
 * FeedbackButton — compact bug-report button for MainMenu, MatchResult, etc.
 *
 * Extracted from FeedbackScreen to avoid the Rollup dual-import warning:
 * App.tsx lazily imports FeedbackScreen (full page) while MainMenu/MatchResult
 * statically import FeedbackButton. Keeping them in the same file forces the
 * static import to pull in the full FeedbackScreen chunk eagerly, defeating
 * code-splitting. This tiny module has no heavy dependencies so it is safe to
 * bundle into the critical-path chunk.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { S } from '../locales/strings.js'
import { useNavigationStore } from './useNavigationStore.js'

const feedbackBtnStyle: React.CSSProperties = {
  background: 'rgba(155,111,232,0.12)',
  border: '1px solid rgba(155,111,232,0.4)',
  borderRadius: 10,
  padding: '10px 18px',
  color: '#b89ef0',
  fontSize: 13,
  fontFamily: 'monospace',
  cursor: 'pointer',
  minHeight: 44,
  letterSpacing: 0.3,
}

export const FeedbackButton: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const { t } = useTranslation()
  const navigate = useNavigationStore((s) => s.navigate)
  return (
    <button
      style={{ ...feedbackBtnStyle, ...style }}
      onClick={() => navigate('feedback')}
    >
      {t(S.FEEDBACK_BTN_REPORT)}
    </button>
  )
}
